import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ImageLoader from '../../../Common/ImageLoader';
import UpgradeProfilePopUp from '../../../Common/Popups/UpgradeProfile';
import AboutVendor from './AboutVendor';
import shortid from 'shortid';

const hideShowContent = event => {
  event.preventDefault();
  const contentShowHide = document.querySelector('.showLessMoreContent');
  const hiddenItems = Array.prototype.slice.call(
    document.querySelectorAll('.contentHide')
  );

  const showing = contentShowHide.textContent === 'Show more';

  hiddenItems.forEach(function (item) {
    if (!showing) {
      item.classList.add('content-hidden');
    } else {
      item.classList.remove('content-hidden');
    }

    contentShowHide.textContent =
      contentShowHide.textContent === 'Show more' ? 'Show Less' : 'Show more';
  });
};

const VendorProfileDetail = props => {
  const [isUpgrade, setUpgrade] = useState(false);
  const [isShowMore, setShowMore] = useState(false);

  return (
    <React.Fragment>
      {!!props.vendorCommonData &&
        Object.keys(props.vendorCommonData).length > 0 &&
        props.match.path === '/vendor/:id' && (
          <div
            className={
              !!props.vendorCommonData &&
              !!props.vendorCommonData.vendor_type &&
              props.vendorCommonData.vendor_type === 'premium'
                ? 'vendor_profile_details vendor_profile_details_premium'
                : 'vendor_profile_details'
            }
          >
            {props.vendorCommonData.vendor_type === 'verified' && (
              <div className="verified-badge">
                <img src="/images/verified-badge.webp" alt="" />
              </div>
            )}
            <div className="left">
              <div className="logo">
                <ImageLoader
                  image={props.vendorCommonData.logo}
                  fallbackImage={'/static/images/FC-Generic-Logo.webp'}
                />
              </div>
              {props.vendorProfile.social_urls.length ? (
                <div className="clsFind_SocialMedia">
                  <span className="social_txt">Find them on Social</span>
                  {props.vendorProfile.social_urls.map(social => (
                    <a
                      href={social.url}
                      target="_blank"
                      key={shortid.generate()}
                      rel="noopener noreferrer"
                    >
                      <img
                        src={`/images/${social.platform.toLowerCase()}.webp`}
                        alt={social.platform}
                      />
                    </a>
                  ))}
                </div>
              ) : (
                ``
              )}
            </div>
            <div className="right">
              <div className="content">
                <h1>{`About ${
                  !!props.vendorCommonData && props.vendorCommonData.name
                }`}</h1>
                {!isShowMore ? <span className="content_blur"></span> : null}
                <span className={!isShowMore ? 'content_open' : null}>
                  {`${props.vendorDescription.slice(0, 331)}`}
                </span>
                <span className="item content-hidden contentHide">
                  {`${props.vendorDescription.slice(331)}`}
                </span>
                <a
                  href="#show more"
                  className="showLessMoreContent"
                  onClick={e => {
                    e.preventDefault();
                    hideShowContent(e);
                    setShowMore(!isShowMore);
                  }}
                >
                  {isShowMore ? 'Show less' : 'Show more'}
                </a>
              </div>
            </div>
          </div>
        )}
      {isUpgrade ? (
        <UpgradeProfilePopUp
          companyName={props.vendorCommonData.name}
          companyId={props.vendorCommonData.company_id}
          setUpgrade={setUpgrade}
        />
      ) : (
        false
      )}
    </React.Fragment>
  );
};

const mapStateToProps = state => {
  return {
    vendorDescription: state.vendorProfile.description,
    vendorCommonData: state.vendorCommon,
    vendorProfile: state.vendorProfile,
  };
};

export default connect(mapStateToProps)(withRouter(VendorProfileDetail));
